import React, { useState } from 'react'
import { Button, Dialog, DialogContent, Grid, IconButton, TextField, Typography, DialogTitle, FormControl, InputLabel, OutlinedInput, InputAdornment, MenuItem, Select } from '@mui/material'
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Navigate } from 'react-router-dom';
import { BRAND } from '../constants/brand';

function UserLogin({ setHandleOpen, handelOpen }) {

    const [branch, setBranch] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSignUp = async (e) => {
        e.preventDefault();
        try {
            // Replace with your backend API URL for signing up
            const response = await axios.post('https://serverdemo.ccsoftwares.com/Users/loginUser', {
                username,
                password,
                branch
            });
            //console.log(response);

            if (!response.data.token) {
                toast.success('Registration successful! You can now log in.')
            }
            // sessionStorage.setItem('username', response.data.user.username);
            // sessionStorage.setItem('role', response.data.user.role);
            const paws = {
                username: response.data.user.username,
                role: response.data.user.role,
                shop: response.data.user.shop,
            };
            sessionStorage.setItem(BRAND.sessionStorageKey, JSON.stringify(paws));

            toast.success('Registration successful! You can now log in.');
            setError('');

            setHandleOpen(false)
            window.location.reload();
            setUsername('');
            setPassword('');

        } catch (err) {
            setSuccess('');
            setError('Error creating account. Please try again.');
            toast.error('Incorrect Login Details')
        }
    };

    const handleClose = () => {
        setHandleOpen(false)
    }

    const Signup = () => {
        Navigate('Signup')
    }
    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                open={handelOpen}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        m: { xs: 2, sm: 3 },
                        width: { xs: '100%', sm: 'auto' },
                        borderRadius: { xs: 2, sm: 3 }
                    }
                }}
            >
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 25,
                        top: 20,
                        height: 50,
                        width: 50,
                        color: (theme) => theme.palette.grey[200],
                    }}
                >
                    <DisabledByDefaultIcon sx={{ color: '#000000', fontSize: '40px' }} />
                </IconButton>
                <DialogTitle sx={{
                    color: '#000000',
                    fontSize: '35px',
                    fontFamily: 'sans-serif',
                    fontWeight: '1000',
                    display: "flex",
                    justifyContent: "center",
                    alignContent: 'center'
                }}>{BRAND.name}</DialogTitle>
                <DialogContent >
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>
                        </Grid>
                    
                        <Grid item xs={12} md={12}>
                            <TextField id="outlined-basic" label="Username" variant="outlined" size='large' fullWidth value={username}
                                onChange={(e) => setUsername(e.target.value)} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                                <OutlinedInput
                                    id="outlined-adornment-password"
                                    fullWidth
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    type={showPassword ? 'text' : 'password'}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                onMouseUp={handleMouseUpPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Password"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <center>
                                <Button
                                    variant="contained"
                                    size='large'
                                    sx={{
                                        width: '70%',
                                        fontFamily: 'sans-serif',
                                    }}
                                    type="submit"
                                    onClick={handleSignUp}
                                >
                                    Login
                                </Button>

                            </center>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog >
        </>

    )
}

export default UserLogin
